import { render } from "./SidebarMobile.vue?vue&type=template&id=0038389f&scoped=true"
import script from "./SidebarMobile.vue?vue&type=script&lang=js"
export * from "./SidebarMobile.vue?vue&type=script&lang=js"

import "./SidebarMobile.vue?vue&type=style&index=0&id=0038389f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0038389f"]])

export default __exports__